var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var nodeFetch = require('node-fetch'); // Webpack will sometimes export default exports in different places


var fetch = nodeFetch.default || nodeFetch;

var _require = require('../operations'),
    getOperations = _require.getOperations;

var _require2 = require('./body.js'),
    addBody = _require2.addBody;

var _require3 = require('./response.js'),
    parseResponse = _require3.parseResponse,
    getFetchError = _require3.getFetchError;

var _require4 = require('./retry.js'),
    shouldRetry = _require4.shouldRetry,
    waitForRetry = _require4.waitForRetry,
    MAX_RETRY = _require4.MAX_RETRY;

var _require5 = require('./url.js'),
    getUrl = _require5.getUrl; // For each OpenAPI operation, add a corresponding method.
// The `operationId` is the method name.


var getMethods = function getMethods(_ref) {
  var basePath = _ref.basePath,
      defaultHeaders = _ref.defaultHeaders,
      agent = _ref.agent,
      globalParams = _ref.globalParams;
  var operations = getOperations();
  var methods = operations.map(function (method) {
    return getMethod({
      method: method,
      basePath: basePath,
      defaultHeaders: defaultHeaders,
      agent: agent,
      globalParams: globalParams
    });
  });
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(methods)));
};

var getMethod = function getMethod(_ref2) {
  var method = _ref2.method,
      basePath = _ref2.basePath,
      defaultHeaders = _ref2.defaultHeaders,
      agent = _ref2.agent,
      globalParams = _ref2.globalParams;
  return _defineProperty({}, method.operationId, function (params, opts) {
    return callMethod({
      method: method,
      basePath: basePath,
      defaultHeaders: defaultHeaders,
      agent: agent,
      globalParams: globalParams,
      params: params,
      opts: opts
    });
  });
};

var callMethod =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref4) {
    var method, basePath, defaultHeaders, agent, globalParams, params, opts, requestParams, url, response, parsedResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _ref4.method, basePath = _ref4.basePath, defaultHeaders = _ref4.defaultHeaders, agent = _ref4.agent, globalParams = _ref4.globalParams, params = _ref4.params, opts = _ref4.opts;
            requestParams = _objectSpread({}, globalParams, params);
            url = getUrl(method, basePath, requestParams);
            _context.next = 5;
            return makeRequestOrRetry({
              url: url,
              method: method,
              defaultHeaders: defaultHeaders,
              agent: agent,
              requestParams: requestParams,
              opts: opts
            });

          case 5:
            response = _context.sent;
            _context.next = 8;
            return parseResponse(response);

          case 8:
            parsedResponse = _context.sent;
            return _context.abrupt("return", parsedResponse);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function callMethod(_x) {
    return _ref5.apply(this, arguments);
  };
}();

var getOpts = function getOpts(_ref6) {
  var _ref6$method = _ref6.method,
      verb = _ref6$method.verb,
      parameters = _ref6$method.parameters,
      defaultHeaders = _ref6.defaultHeaders,
      agent = _ref6.agent,
      body = _ref6.requestParams.body,
      opts = _ref6.opts;
  var optsA = addHttpMethod(verb, opts);
  var optsB = addDefaultHeaders(defaultHeaders, optsA);
  var optsC = addBody(body, parameters, optsB);
  var optsD = addAgent(agent, optsC);
  return optsD;
}; // Add the HTTP method based on the OpenAPI definition


var addHttpMethod = function addHttpMethod(verb, opts) {
  return _objectSpread({}, opts, {
    method: verb.toUpperCase()
  });
}; // Assign default HTTP headers


var addDefaultHeaders = function addDefaultHeaders(defaultHeaders, opts) {
  return _objectSpread({}, opts, {
    headers: _objectSpread({}, defaultHeaders, opts.headers)
  });
}; // Assign fetch agent (like for example HttpsProxyAgent) if there is one


var addAgent = function addAgent(agent, opts) {
  if (agent) {
    return _objectSpread({}, opts, {
      agent: agent
    });
  }

  return opts;
};

var makeRequestOrRetry =
/*#__PURE__*/
function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_ref7) {
    var url, method, defaultHeaders, agent, requestParams, opts, index, optsA, _ref9, response, error;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = _ref7.url, method = _ref7.method, defaultHeaders = _ref7.defaultHeaders, agent = _ref7.agent, requestParams = _ref7.requestParams, opts = _ref7.opts;
            index = 0;

          case 2:
            if (!(index <= MAX_RETRY)) {
              _context2.next = 19;
              break;
            }

            optsA = getOpts({
              method: method,
              defaultHeaders: defaultHeaders,
              agent: agent,
              requestParams: requestParams,
              opts: opts
            }); // eslint-disable-next-line no-await-in-loop

            _context2.next = 6;
            return makeRequest(url, optsA);

          case 6:
            _ref9 = _context2.sent;
            response = _ref9.response;
            error = _ref9.error;

            if (!(shouldRetry({
              response: response,
              error: error
            }) && index !== MAX_RETRY)) {
              _context2.next = 13;
              break;
            }

            _context2.next = 12;
            return waitForRetry(response);

          case 12:
            return _context2.abrupt("continue", 16);

          case 13:
            if (!(error !== undefined)) {
              _context2.next = 15;
              break;
            }

            throw error;

          case 15:
            return _context2.abrupt("return", response);

          case 16:
            index++;
            _context2.next = 2;
            break;

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function makeRequestOrRetry(_x2) {
    return _ref8.apply(this, arguments);
  };
}();

var makeRequest =
/*#__PURE__*/
function () {
  var _ref10 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(url, opts) {
    var response, errorA;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch(url, opts);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", {
              response: response
            });

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            errorA = getFetchError(_context3.t0, url, opts);
            return _context3.abrupt("return", {
              error: errorA
            });

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 7]]);
  }));

  return function makeRequest(_x3, _x4) {
    return _ref10.apply(this, arguments);
  };
}();

module.exports = {
  getMethods: getMethods
};